import React from 'react';
import { useAppSelector } from 'src/utils/Hooks';
import { isTopicOrTopicGroupType } from '../../utils';
import { NonTopicOrTopicGroupPage } from './NonTopicOrTopicGroupPage';
import { TopicOrTopicGroupPage } from './TopicOrTopicGroupPage';
import { OriginalTotalTrafficPage } from './OriginalTotalTrafficPage';
import { shouldShowBeaconProTopics } from 'src/utils/app';

/**
 * The "Total" tab on the Traffic page
 */
const TotalTrafficPage = () => {
  const mainEntityType = useAppSelector((state) => state.entityService.mainEntity.type);
  const showTopicsPage = shouldShowBeaconProTopics() && isTopicOrTopicGroupType(mainEntityType);
  const showTopicsPageForNonTopics = shouldShowBeaconProTopics() && !isTopicOrTopicGroupType(mainEntityType);

  if (showTopicsPage) {
    return <TopicOrTopicGroupPage />;
  }
  if (showTopicsPageForNonTopics) {
    return <NonTopicOrTopicGroupPage />;
  }
  return <OriginalTotalTrafficPage />;
};

export default TotalTrafficPage;
